/**
 * Missing, null, and any non-true value are not a test store.
 * @param {object | boolean | null | undefined} storeOrFlag
 * @returns {boolean}
 */
export function isTestStoreFlag(storeOrFlag) {
  if (storeOrFlag && typeof storeOrFlag === "object") {
    return storeOrFlag.isTestStore === true;
  }
  return storeOrFlag === true;
}

/**
 * Attach a boolean isTestStore without changing active or any other field.
 * Marking a location as a test store must leave it active.
 * @param {object} body
 * @param {boolean | null | undefined} isTestStore
 * @returns {object}
 */
export function applyTestStoreFlag(body, isTestStore) {
  return {
    ...body,
    isTestStore: isTestStore === true,
  };
}
